export function ConvertToCapitalizedDashSeparated(dbString: string) {
  let formattedStatus = dbString.replace(/([A-Z])/, ' - $&');
  return formattedStatus.substring(0, 1).toLocaleUpperCase() + formattedStatus.substring(1);
}
